import { Book, BookBookmark, Gear, GridFour, PuzzlePiece, Question, SquaresFour, } from "@phosphor-icons/react";
import { FC, useEffect, useState } from "react";
import { generatePath, useLocation } from "react-router-dom";
import { ISelectOption, Select } from "ui/form";
import { AppPaths } from "../../../App/App.constant";
import { useAppContext } from "../../../App/App.hooks";
import { LanguageSwitcherViewModel } from "../../../LanguageSwitcher/LanguageSwitcher.viewmodel";
import { useUserContext } from "../../../User/User.hooks";
import { Nav, NavLink, NavLinkContent, NavLinkIcon, NavLinkText, SelectContainer, StyledSidebar } from "./Sidebar.style";

export const Sidebar: FC = () => {
  const { pathname } = useLocation();
  const { accountPermissions, currentLanguage, accountLanguages, setCurrentLanguage } = useUserContext();
  const { isSidebarCollapsed } = useAppContext();
  const { languageOptions } = LanguageSwitcherViewModel();
  const [selectValue, setSelectValue] = useState<ISelectOption>();

  useEffect(() => {
    const value = languageOptions.find((option) => option.value === currentLanguage);
    setSelectValue(value);
  }, [languageOptions, currentLanguage]);

  const puzzleSetsUrl = generatePath(AppPaths.puzzleSet, {
    puzzle: undefined,
  });

  return (
    <StyledSidebar>
      <Nav>
        <NavLink
          to={AppPaths.root}
          collapsed={isSidebarCollapsed}
          active={
            pathname === AppPaths.crossword.root ||
            pathname === AppPaths.crossword.archive
          }
        >
          <NavLinkContent>
            <NavLinkIcon>
              <GridFour
                size={20}
                weight={
                  pathname === AppPaths.crossword.root ||
                    pathname === AppPaths.crossword.archive
                    ? 'fill'
                    : 'regular'
                }
              />
            </NavLinkIcon>
            <NavLinkText>Crossword</NavLinkText>
          </NavLinkContent>
        </NavLink>
        <NavLink to={AppPaths.grids} collapsed={isSidebarCollapsed} active={pathname === AppPaths.grids}>
          <NavLinkContent>
            <NavLinkIcon>
              <SquaresFour
                size={20}
                weight={pathname === AppPaths.grids ? 'fill' : 'regular'}
              />
            </NavLinkIcon>
            <NavLinkText>Grids</NavLinkText>
          </NavLinkContent>
        </NavLink>
        <NavLink to={puzzleSetsUrl} collapsed={isSidebarCollapsed} active={pathname.includes(puzzleSetsUrl)}>
          <NavLinkContent>
            <NavLinkIcon>
              <PuzzlePiece
                size={20}
                weight={pathname.includes(puzzleSetsUrl) ? 'fill' : 'regular'}
              />
            </NavLinkIcon>
            <NavLinkText>Puzzle sets</NavLinkText>
          </NavLinkContent>
        </NavLink>
        {/* <NavLink to={AppPaths.crossword.archive} active={pathname === AppPaths.crossword.archive}>
					<NavLinkContent>
						<Archive
							size={20}
							weight={pathname === AppPaths.crossword.archive ? 'fill' : 'regular'}
						/>
						<span>Archive</span>
					</NavLinkContent>
				</NavLink> */}
        {accountPermissions.canManageWordlist && (
          <NavLink
            to={AppPaths.wordList}
            collapsed={isSidebarCollapsed}
            active={pathname === AppPaths.wordList}
          >
            <NavLinkContent>
              <NavLinkIcon>
                <Book
                  size={20}
                  weight={pathname === AppPaths.wordList ? 'fill' : 'regular'}
                />
              </NavLinkIcon>
              <NavLinkText>Wordlist</NavLinkText>
            </NavLinkContent>
          </NavLink>
        )}
        {currentLanguage === 'no' && accountPermissions.canManageWordlist && (
          <NavLink
            to={AppPaths.kryssordboka}
            collapsed={isSidebarCollapsed}
            active={pathname === AppPaths.kryssordboka}
          >
            <NavLinkContent>
              <NavLinkIcon>
                <BookBookmark
                  size={20}
                  weight={pathname === AppPaths.kryssordboka ? 'fill' : 'regular'}
                />
              </NavLinkIcon>
              <NavLinkText>Kryssordboka</NavLinkText>
            </NavLinkContent>
          </NavLink>
        )}
      </Nav>
      <Nav>
        {!!accountLanguages.length && (
          <SelectContainer collapsed={isSidebarCollapsed}>
            <Select
              options={languageOptions}
              value={selectValue}
              menuPlacement='top'
              placeholder='Choose language'
              onChange={(option) => {
                if (option) {
                  setSelectValue(option);
                  setCurrentLanguage(option.value);
                }
              }}
            />
          </SelectContainer>
        )}
        <NavLink to={AppPaths.settings} collapsed={isSidebarCollapsed} active={pathname === AppPaths.settings}>
          <NavLinkContent>
            <NavLinkIcon>
              <Gear
                size={20}
                weight={pathname === AppPaths.settings ? 'fill' : 'regular'}
              />
            </NavLinkIcon>
            <NavLinkText>Settings</NavLinkText>
          </NavLinkContent>
        </NavLink>
        <NavLink to={AppPaths.help} collapsed={isSidebarCollapsed} active={pathname === AppPaths.help}>
          <NavLinkContent>
            <NavLinkIcon>
              <Question
                size={20}
                weight={pathname === AppPaths.help ? 'fill' : 'regular'}
              />
            </NavLinkIcon>
            <NavLinkText>Help</NavLinkText>
          </NavLinkContent>
        </NavLink>
      </Nav>
    </StyledSidebar>
  );
};
